import axios from '@/axios.js'

const state = () => ({
    analisas: [],
    total: null,
    last: null
})

const mutations = {
  SET_ANALISAS (state, payload) {
    state.analisas = payload
  },
  SET_TOTALS (state, payload) {
    state.total = payload
  },
  SET_LAST (state, payload) {
    state.last = payload
  },
  PUSH_ANALISAS (state, item) {
    state.analisas.push(item)
  },
  ADD_ANALISA (state, item) {
    state.analisas.unshift(item)
  },
  UPDATE_ANALISA (state, analisa) {
    const analisaIndex = state.analisas.findIndex((p) => p.id === analisa.task_parent)
    Object.assign(state.analisas[analisaIndex], analisa)
  },
  REMOVE_ANALISA (state, itemId) {
    const ItemIndex = state.analisas.findIndex((p) => p.id === itemId)
    state.analisas.splice(ItemIndex, 1)
  },
}

const actions = {
  fetchAnalisa ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.get(`/task-list-analisa/${obj.search}/${obj.bidang}/${obj.divisi}/${obj.kelompok}/${obj.sub}?page=${obj.page}`)
        .then((response) => {
          if (obj.action === 'create') {
            commit('SET_ANALISAS', response.data.data.tasks)
            commit('SET_TOTALS', response.data.data.total)
            commit('SET_LAST', response.data.data.last_page)
          } else {
            for (let i = 0; i < response.data.data.tasks.length; i++) {
              commit('PUSH_ANALISAS', response.data.data.tasks[i])
            }
          }
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  addAnalisa ({ commit }, task) {
    return new Promise((resolve, reject) => {
      axios.post('/task-add-analisa', task)
        .then((response) => {
          commit('ADD_ANALISA', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateAnalisa ({ commit }, task) {
    return new Promise((resolve, reject) => {
      axios.post(`/task-update-analisa/`, task)
        .then((response) => {
          commit('UPDATE_ANALISA', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeTask ({ commit }, taskId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/task-delete-analisa/${taskId}`)
        .then((response) => {
          commit('REMOVE_ANALISA', taskId)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  }
}

export default {
  isRegistered: false,
  namespaced: true,
  state,
  actions,
  mutations
}